import { type ShoppingCartItem as SCI, ShoppingCartItemTypeEnum } from '../generated/checkout.graphql';
import * as ShoppingCartItemPriceBreakdown from './ShoppingCartItemPriceBreakdown';
import { take } from '../util/takePayload';

export type SeatingInfo = {
  seatIds: string[];
};

export type ShoppingCartItem = {
  typeHash: string;
  name?: string;
  itemId: number;
  itemType: ShoppingCartItemTypeEnum;
  count?: number;
  amount?: number;
  details?: unknown;
  seatingInfo?: SeatingInfo;
  breakdown?: ShoppingCartItemPriceBreakdown.ItemBreakdown;
};

export const fromGql = (gqlItem: SCI): ShoppingCartItem => ({
  ...(take(gqlItem, 'typeHash', 'name', 'itemId', 'itemType', 'count', 'amount', 'details') as ShoppingCartItem),
  seatingInfo: seatingInfoFromDetails(gqlItem),
  breakdown: gqlItem.breakdown ? ShoppingCartItemPriceBreakdown.fromGql(gqlItem.breakdown) : undefined,
});

const seatingInfoFromDetails = ({ itemType, details }: SCI): SeatingInfo | undefined => {
  if (itemType != ShoppingCartItemTypeEnum.SeatTicket) {
    return undefined;
  }

  const seatIds = details.seatIds;
  if (!seatIds) {
    return undefined;
  }

  return { seatIds: seatIds.map((seatDetails: { seatId: string }) => seatDetails.seatId) };
};
